import { Result } from '@standardnotes/domain-core';
export class EncryptMessage {
    constructor(operators) {
        this.operators = operators;
    }
    execute(dto) {
        const operator = this.operators.defaultOperator();
        const encrypted = operator.asymmetricEncrypt({
            stringToEncrypt: JSON.stringify(dto.message),
            senderKeyPair: dto.keys.encryption,
            senderSigningKeyPair: dto.keys.signing,
            recipientPublicKey: dto.recipientPublicKey,
        });
        return Result.ok(encrypted);
    }
}
